import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=2a1da5de&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageFooter.vue"
export default component.exports